import React from 'react';
import { FormattedMessage } from 'react-intl';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import * as types from 'hellospa/page/prep-and-send/data/types';
import QuotaAlert from './quota-alert';
import styles from './styles.scss';

const DocumentQuotaAlert: types.TriggerComponent = ({ onCancel, onSkip, stage }) => {
  // conditionally setting the trigger type because if this modal is triggered in the load
  // stage (the FileUploaderPage), it can be skipped and the request can still be created,
  // but when triggered on the submit stage (the ReviewPage), it cannot be skipped, since
  // creating a signature request isn't allowed if the user is out of documents
  const triggerType = stage === 'load' ? onSkip : onCancel;
  return (
    <QuotaAlert
      triggerType={triggerType}
      type="signature request"
    >
      <div className={styles.quotaText}>
        <FormattedMessage
          id=""
          description="quota alert text for no remaining free documents"
          defaultMessage="Your current plan does not have any more document sends this month. You can still create a request, but won't be able to send it out until you have upgraded to a higher plan." />
        <br /><br />
        <FormattedMessage
          id=""
          description="quota alert sub text with information about request being saved as draft"
          defaultMessage="This request will be saved as a draft on the 'Documents' page and will need to be sent out manually after you upgrade." />
      </div>
    </QuotaAlert>
  );
};

DocumentQuotaAlert.needsTrigger = (state, _formik) => {
  const isHelloSign = !selectors.isHelloFax(state);
  const isAtDocumentLimit = selectors.isAtDocumentLimit(state);
  const isTemplateRequest = selectors.isTemplateRequest(state);
  const isEmbedded = selectors.isEmbedded(state);

  // check if it's not a template request & is also HelloSign
  // we don't show quota alerts for embedded requests
  return !isEmbedded && !isTemplateRequest && isHelloSign && isAtDocumentLimit;
};

export default DocumentQuotaAlert;
